import React, { FC } from 'react'
import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import { LDCardTwoCol, LMBgHeader, withHidden, FSMBtnNext, Typography } from '@dg-shared'
import { useTranslate } from '../../../hooks/shared'
import { TRANSLATIONS as T } from '../../../constants/translations-constants'
import { logoMax, logoMin } from 'BrandedImages'
import { redirect, getDataComponentName } from '@dg-util'
import { FlowName } from '../../../config'
import BrandConfig from 'BrandConfig'

// Nord Forsikring takes over the discontinued Instabank insurance products (DFE-4061).
const NORD_FORSIKRING_LINK = 'https://www.nordforsikring.no'

const MobileScreen = withHidden(LMBgHeader, true)
const DesktopScreen = withHidden(LDCardTwoCol, false)

const useStyles = makeStyles()((theme: Theme) => ({
  // Title + privacy link stay grouped tightly at the top; the card's space-between
  // right column then distributes this group, body, button and footer down the height.
  intro: {
    width: '100%',
  },

  title: {
    lineHeight: '1.2 !important',
    fontSize: '28px !important',
    ...theme.brand.typography.overrides?.authTitle,
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  },

  disclaimer: {
    marginBottom: theme.spacing(2),
    color: theme.brand.colors.textMain,
    ...theme.brand.assets.layout?.AuthStrategyDisclaimer,
    textAlign: 'center',
    '& a': {
      textDecoration: 'underline',
      color: theme.brand.colors.linkMain,
    },
  },

  body: {
    marginBottom: theme.spacing(2),
    color: theme.brand.colors.textMain,
    ...theme.brand.assets.layout?.AuthStrategyDisclaimer,
    textAlign: 'center',
    '& a': {
      textDecoration: 'underline',
      color: theme.brand.colors.linkMain,
    },
  },

  description: {
    marginTop: theme.spacing(2),
    color: theme.brand.colors.textDisclaimer,
    ...theme.brand.assets.layout?.AuthStrategyDisclaimer,
    textAlign: 'center',
  },
}))

const QBClosedPage: FC = () => {
  const { t } = useTranslate(T.AUTH)
  const { classes } = useStyles()

  const goToMyPages = () => redirect(`/?flow=${FlowName.MY_PAGES}`)

  const disclaimerBlock = (
    <Typography size='small' className={classes.disclaimer}>
      <a href={BrandConfig.PRIVACY_POLICY_LINK} target='_blank' rel='noreferrer'>
        {`${t('disclaimer.0')} ${t('disclaimer.1')}`}
      </a>
    </Typography>
  )

  const bodyBlock = (
    <Typography size='small' className={classes.body}>
      {t('qbClosed.body.0')}
      <a href={NORD_FORSIKRING_LINK} target='_blank' rel='noreferrer'>
        {t('qbClosed.body.1')}
      </a>
      {t('qbClosed.body.2')}
    </Typography>
  )

  const descriptionBlock = (
    <Typography size='small' className={classes.description}>
      {t('description')}
    </Typography>
  )

  return (
    <div data-componentname={getDataComponentName(__filename)}>
      <MobileScreen
        headerTitle={t('title')}
        textLogoAlt={t('title')}
        imageLogo={logoMin}
        brandPageBackground='mainMobile'
      >
        {disclaimerBlock}
        {bodyBlock}
        <FSMBtnNext handleClick={goToMyPages} buttonText={t('qbClosed.btn')} />
        {descriptionBlock}
      </MobileScreen>
      <DesktopScreen
        imageLogo={logoMax}
        textLogoAlt={t('title')}
        brandPageBackground='main'
        brandPageBackgroundCard='mainCard'
      >
        <div className={classes.intro}>
          <Typography type='h1' className={classes.title}>
            {t('title')}
          </Typography>
          {disclaimerBlock}
        </div>
        {bodyBlock}
        <FSMBtnNext handleClick={goToMyPages} buttonText={t('qbClosed.btn')} />
        {descriptionBlock}
      </DesktopScreen>
    </div>
  )
}

export default QBClosedPage
